import { menu_scroll } from '../modules/menu';
import { waypoints } from '../modules/inview';
import { sliders } from '../modules/sliders';

export default {
	init() {
		// JavaScript to be fired on all pages

		$('body').removeClass('scrolled');
		waypoints();
		menu_scroll();
		sliders();
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js